import {
  Card,
  CardHeader,
  CardFooter,
  Table,
  Container,
  Row,
} from "reactstrap";
// core components
import Header from "components/Headers/Header.js";
import { useCallback, useEffect, useState } from "react";
import moment from "moment";
import Pagination from "components/Pagination";
import { getContactUsList } from "services/_contactUs";

const ContactUs = () => {
  const [contactUsData, setContactUsData] = useState([]);
  const [records, setRecords] = useState([]);
  const [page, setPage] = useState(1);
  const [perPage] = useState(10);
  const [totalPages, setTotalPages] = useState(0);
  const [totalRecords, setTotalRecords] = useState(0);

  const initialData = useCallback(async () => {
    let payload = `page=${page}&per_page=${perPage}`;

    const data = await getContactUsList(payload);
    if (data.data) {
      setRecords(data.data.records || []);
      setContactUsData(data.data.records);
      setTotalRecords(data.data.total_records || 0);
      if (data.data.total_records && perPage) {
        setTotalPages(Math.ceil(data.data.total_records / perPage));
      }
    }
  }, [page, perPage]);

  useEffect(() => {
    initialData();
  }, [initialData]);

  const prevButton = async () => {
    if (page > 1) {
      setPage(page - 1);
    }
  };

  const nextButton = async () => {
    if (totalPages > page) {
      setPage(page + 1);
    }
  };

  return (
    <>
      <Header />
      <Container className="mt--7" fluid>
        <Row>
          <div className="col">
            <Card className="shadow">
              <CardHeader className="border-0 ">
                <h3>Contact Us </h3>
              </CardHeader>
              <Table className="align-items-center table-flush" responsive>
                <thead className="thead-light">
                  <tr>
                    <th scope="col">#</th>
                    <th scope="col">Name</th>
                    <th scope="col">Email</th>
                    <th scope="col">Phone Number</th>
                    <th scope="col">Country</th>
                    <th scope="col">Subject</th>
                    <th scope="col">Message</th>
                    <th scope="col">Created At</th>
                  </tr>
                </thead>
                <tbody>
                  {contactUsData.length > 0 ? (
                    contactUsData.map((user, index) => {
                      return (
                        <>
                          <tr key={index}>
                            <th scope="row">
                              {(page - 1) * perPage + index + 1}
                            </th>
                            <td>{user.name}</td>
                            <td>{user.email}</td>
                            <td>{user.phone}</td>
                            <td>{user.country}</td>
                            <td>{user.subject}</td>
                            <td>{user.message}</td>
                            <td>
                              {user.created_at
                                ? moment(user.created_at).format(
                                    "DD MMMM, YYYY"
                                  )
                                : "-"}
                            </td>
                          </tr>
                        </>
                      );
                    })
                  ) : (
                    <tr>
                      <td>No record found</td>
                    </tr>
                  )}
                </tbody>
              </Table>
              <CardFooter className="py-4">
                <Pagination
                  page={page}
                  perPage={perPage}
                  totalRecords={totalRecords}
                  totalPages={totalPages}
                  records={records}
                  prevButton={prevButton}
                  nextButton={nextButton}
                />
              </CardFooter>
            </Card>
          </div>
        </Row>
      </Container>
    </>
  );
};

export default ContactUs;
